<template>
    <div class="tech-solution">
        <div class="tech-solution__description">
            <p class="screen-subtitle -trAnim-1">Solution</p>
            <h2 class="screen-title -trAnim-2">Tech</h2>
        </div>
        <div class="tech-solution__scheme">
            <div class="tech-solution__canvas">
                <div class="processor-block">
                    <p class="title -trAnim-4">Editor</p>
                    <img class="processor -trAnim-3" src="../assets/images/processor.png" alt="processor">
                    <div class="processor__arrow -trAnim-4">
                        <svg width="132" height="117" viewBox="0 0 132 117" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_216_276)">
                                <path d="M37.5 71.5L36 41.5L46 41L47.5 63L81.5 62.5L83 71L37.5 71.5Z" fill="var(--color-path-1)"/>
                                <path d="M57 55.5L54.5 36.5L65 36L67 47L84.5 46.5L86 54.5L57 55.5Z" fill="var(--color-path-2)"/>
                                <path d="M37.5 71.5L36 41.5L46 41L47.5 63L81.5 62.5L83 71L37.5 71.5Z" stroke="black" stroke-width="0.1"/>
                                <path d="M57 55.5L54.5 36.5L65 36L67 47L84.5 46.5L86 54.5L57 55.5Z" stroke="black" stroke-width="0.1"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_216_276" x="0.947754" y="0.947998" width="130.112" height="115.603" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dx="5" dy="5"/>
                                    <feGaussianBlur stdDeviation="20"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_216_276"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_216_276" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="processor__arrow -trAnim-5">
                        <svg width="132" height="117" viewBox="0 0 132 117" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_220_281)">
                                <path d="M38.9762 71L40.7619 61.9483H74.6905L76.4762 40.8276H86L84.8095 71H38.9762Z" fill="var(--color-path-1)"/>
                                <path d="M37.7857 45.6552L36 54.7069L65.1667 55.3103L66.9524 36H56.8333L55.0476 46.8621L37.7857 45.6552Z" fill="var(--color-path-2)"/>
                                <path d="M38.9762 71L40.7619 61.9483H74.6905L76.4762 40.8276H86L84.8095 71H38.9762Z" stroke="black" stroke-width="0.1"/>
                                <path d="M37.7857 45.6552L36 54.7069L65.1667 55.3103L66.9524 36H56.8333L55.0476 46.8621L37.7857 45.6552Z" stroke="black" stroke-width="0.1"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_220_281" x="0.939453" y="0.950012" width="130.113" height="115.1" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dx="5" dy="5"/>
                                    <feGaussianBlur stdDeviation="20"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_220_281"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_220_281" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="processor-block">
                    <p class="title -trAnim-5">Infra</p>
                    <img class="processor -trAnim-4" src="../assets/images/processor.png" alt="processor">
                    <div class="processor__arrow -trAnim-5">
                        <svg width="132" height="117" viewBox="0 0 132 117" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_216_276)">
                                <path d="M37.5 71.5L36 41.5L46 41L47.5 63L81.5 62.5L83 71L37.5 71.5Z" fill="var(--color-path-2)"/>
                                <path d="M57 55.5L54.5 36.5L65 36L67 47L84.5 46.5L86 54.5L57 55.5Z" fill="var(--color-path-1)"/>
                                <path d="M37.5 71.5L36 41.5L46 41L47.5 63L81.5 62.5L83 71L37.5 71.5Z" stroke="black" stroke-width="0.1"/>
                                <path d="M57 55.5L54.5 36.5L65 36L67 47L84.5 46.5L86 54.5L57 55.5Z" stroke="black" stroke-width="0.1"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_216_276" x="0.947754" y="0.947998" width="130.112" height="115.603" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dx="5" dy="5"/>
                                    <feGaussianBlur stdDeviation="20"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_216_276"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_216_276" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <div class="processor__arrow -trAnim-6">
                        <svg width="132" height="117" viewBox="0 0 132 117" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_220_281)">
                                <path d="M38.9762 71L40.7619 61.9483H74.6905L76.4762 40.8276H86L84.8095 71H38.9762Z" fill="var(--color-path-2)"/>
                                <path d="M37.7857 45.6552L36 54.7069L65.1667 55.3103L66.9524 36H56.8333L55.0476 46.8621L37.7857 45.6552Z" fill="var(--color-path-1)"/>
                                <path d="M38.9762 71L40.7619 61.9483H74.6905L76.4762 40.8276H86L84.8095 71H38.9762Z" stroke="black" stroke-width="0.1"/>
                                <path d="M37.7857 45.6552L36 54.7069L65.1667 55.3103L66.9524 36H56.8333L55.0476 46.8621L37.7857 45.6552Z" stroke="black" stroke-width="0.1"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_220_281" x="0.939453" y="0.950012" width="130.113" height="115.1" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dx="5" dy="5"/>
                                    <feGaussianBlur stdDeviation="20"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_220_281"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_220_281" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="processor-block">
                    <p class="title -trAnim-6">planet</p>
                    <img class="processor -trAnim-5" src="../assets/images/processor-middle.png" alt="processor">
                    <img class="processor-small -trAnim-6" src="../assets/images/processor-small.png" alt="processor">
                </div>
                <div class="processor-block">
                    <p class="title -trAnim-7">rountime</p>
                    <img class="processor -trAnim-6" src="../assets/images/processor-middle.png" alt="processor">
                    <img class="processor-small -trAnim-7" src="../assets/images/processor-small.png" alt="processor">
                </div>
                <div class="reward -trAnim-8">
                    <div class="processor__arrow">
                        <svg width="132" height="117" viewBox="0 0 132 117" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_216_276)">
                                <path d="M37.5 71.5L36 41.5L46 41L47.5 63L81.5 62.5L83 71L37.5 71.5Z" fill="var(--color-path-1)"/>
                                <path d="M57 55.5L54.5 36.5L65 36L67 47L84.5 46.5L86 54.5L57 55.5Z" fill="var(--color-path-2)"/>
                                <path d="M37.5 71.5L36 41.5L46 41L47.5 63L81.5 62.5L83 71L37.5 71.5Z" stroke="black" stroke-width="0.1"/>
                                <path d="M57 55.5L54.5 36.5L65 36L67 47L84.5 46.5L86 54.5L57 55.5Z" stroke="black" stroke-width="0.1"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_216_276" x="0.947754" y="0.947998" width="130.112" height="115.603" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dx="5" dy="5"/>
                                    <feGaussianBlur stdDeviation="20"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_216_276"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_216_276" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                    <p>Rewards & costs</p>
                    <div class="processor__arrow">
                        <svg width="132" height="117" viewBox="0 0 132 117" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_216_276)">
                                <path d="M37.5 71.5L36 41.5L46 41L47.5 63L81.5 62.5L83 71L37.5 71.5Z" fill="var(--color-path-1)"/>
                                <path d="M57 55.5L54.5 36.5L65 36L67 47L84.5 46.5L86 54.5L57 55.5Z" fill="var(--color-path-2)"/>
                                <path d="M37.5 71.5L36 41.5L46 41L47.5 63L81.5 62.5L83 71L37.5 71.5Z" stroke="black" stroke-width="0.1"/>
                                <path d="M57 55.5L54.5 36.5L65 36L67 47L84.5 46.5L86 54.5L57 55.5Z" stroke="black" stroke-width="0.1"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_216_276" x="0.947754" y="0.947998" width="130.112" height="115.603" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                    <feOffset dx="5" dy="5"/>
                                    <feGaussianBlur stdDeviation="20"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_216_276"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_216_276" result="shape"/>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
                <p class="nomocracy -trAnim-7">Nomocracy</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'techSolutionScreen',
    data() {
        return {

        }
    }
}
</script>

<style lang='scss'>
    .tech-solution {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;

        @media screen and (max-width: point(sm)) {
            padding-top: 6rem !important;
        }

        &:before {
            content: '';
            display: block;
            position: absolute;
            background: url(../assets/images/blur-7.png) no-repeat;
            background-size: contain;
            background-position: center;
            width: 100vw;
            height: 200vh;
            min-width: 200vh;
            right: 0;
            left: 0;
            opacity: .7;
            z-index: 1;
        }

        &:after {
            content: '';
            display: block;
            position: absolute;
            background: url(../assets/images/blur-8.png) no-repeat;
            background-size: contain;
            background-position: center;
            width: 100vw;
            height: 100vh;
            min-width: 100vh;
            left: -50vw;
            top: 0;
            opacity: .7;
            z-index: 1;
        }
    }
    .tech-solution {
        .tech-solution__description {
            z-index: 3;
            .screen-subtitle {
                margin-top: 2rem;
            }

            .screen-title {
                position: relative;
                margin-top: 1rem;
            }
        }
    }
    .tech-solution__scheme {
        width: 100%; height: 100%;
        max-height: 100%;
        position: relative;
        z-index: 2;

        .tech-solution__canvas {
            position: absolute;
            left: 50%; top: 40%;
            transform: translate(-50%, -50%);
            width: 60.625em;
            height: 43.4375em;

            @media screen and (max-width: point(sm)) {
                width: 100%;
                height: 100%;
                top: 0; left: 0;
                transform: translate(0);
            }

            &:after {
                content: '';
                display: block;
                position: absolute;
                background: url(../assets/images/tech-circles.png) no-repeat;
                background-size: cover;
                background-position: center;
                width: 220%;
                height: 220%;
                left: -70%;
                top: -50%;
                z-index: -1;
            }
        }

        .processor__arrow {
            position: absolute;
            width: 10em;
            height: 6.875em;
            svg {width: 100%; height: 100%; min-width: 100%; min-height: 100%;}
            @media screen and (max-width: point(sm)) {width: 8em; height: 4.875em;}
        }

        .processor-block {
            position: absolute;
            .processor {
                width: 20.875em;
                height: 14.125em;
                img {width: 100%; height: 100%;}
            }
            .title {
                position: absolute;
                @include font-azonix;
                font-size: 1.5em;
                left: 60%;
                bottom: 100%;
                &:before {
                    content: '';
                    position: absolute;
                    left: calc(50% - .15em); top: calc(100% + 2px);
                    width: .3em;
                    height: 2em;
                    background: url(../assets/images/line-circle.png) no-repeat;
                    background-size: contain;
                    background-position: center;

                }
                @media screen and (max-width: point(sm)) {
                    font-size: 1em;
                }
            }
            .processor-small {
                position: absolute;
                left: 80%;
                top: 80%;
                width: 4em; height: auto;
            }
            .processor__arrow:nth-child(3) {
                top: 52%; left: -8%;
                @media screen and (max-width: point(sm)) {top:55%; left: 0;}
            }
            .processor__arrow:nth-child(4) {
                bottom: -2%; right: -8%;
                @media screen and (max-width: point(sm)) {bottom: 10%; right: 0;}
            }
        }

        .reward {
            position: absolute;
            p {
                @include font-medium;
                font-size: 1.375em;
                @media screen and (max-width: point(sm)) {font-size: 1em;}
            }
            .processor__arrow:first-child {left: 30%; bottom: 20%; transform: rotate(180deg);}
            .processor__arrow:last-child {right: 30%; top: 30%;}
        }

        .nomocracy {
            position: absolute;
            @include font-azonix;
            font-size: 1.5em;
            left: 10%;
            top: 70%;
            &:before {
                content: '';
                position: absolute;
                left: calc(50% - .25em); top: calc(100% + 2px);
                width: .5em;
                height: 3em;
                background: url(../assets/images/line-circle.png) no-repeat;
                background-size: contain;
                background-position: center;
            }
            @media screen and (max-width: point(sm)) {font-size: 1.25em; top: 90%;}
        }
    }
    .tech-solution__scheme {
        .processor-block:nth-child(1) {
            left: 0; top: 0;
            .processor__arrow:nth-child(3):before {
                content: 'Listing';
                position: absolute;
                right: 40%; top: 70%;
                @include font-regular;
                font-size: 1.375em;
                @media screen and (max-width: point(sm)) {font-size: 1em;}
            }
            @media screen and (max-width: point(sm)) {top: 0;}
        }
        .processor-block:nth-child(2) {
            left: 30%; top: 25%;
            .processor__arrow:nth-child(3):before {
                content: 'Exchange';
                position: absolute;
                right: 40%; top: 70%;
                @include font-regular;
                font-size: 1.375em;
                @media screen and (max-width: point(sm)) {font-size: 1em;}
            }
            @media screen and (max-width: point(sm)) {top: 27%;}
        }
        .processor-block:nth-child(3) {
            left: 40%; top: 70%;
            .processor {width: 13em; height: 9.625em;}
            .title {
                left: 40%; 
                bottom: 120%;
                @media screen and (max-width: point(sm)) {left: 0; top: 90%; bottom: auto;}
            }
            @media screen and (max-width: point(sm)) {
                .title:before {
                    transform: scale(-1);
                    bottom: calc(100% + 2px);
                    top: auto;
                }
            }
            @media screen and (max-width: point(sm)) {left: 0; top: 60%;}
        }
        .processor-block:nth-child(4) {
            left: 75%; top: 35%;
            .processor {width: 13em; height: 9.625em;}
            .title {left: 40%; bottom: 120%;}
            @media screen and (max-width: point(sm)) {left: 50%; top: 68%;}
        }
        .reward {
            left: 25%; top: 95%;
            @media screen and (max-width: point(sm)) {left: 55%; top: 95%;}
        }
    }

    // processor arrow animation
    .processor__arrow {
        --color-path-1: rgba(255, 255, 255, .3);
        --color-path-2: white;
        animation: 1.5s lighten infinite;

        svg path {
            transition: fill .5s ease;
        }
    }
    @keyframes lighten {
        from {
            --color-path-1: rgba(255, 255, 255, .3);
            --color-path-2: white;
        }
        50% {
            --color-path-1: white;
            --color-path-2: rgba(255, 255, 255, .3);
        }
        to {
            --color-path-1: rgba(255, 255, 255, .3);
            --color-path-2: white;
        }
    }

    // tech canvas adaptive
    .tech-solution__canvas {
        @media screen and (min-aspect-ratio: 970 / 710) {
            font-size: .9rem;
        }
        @media screen and (min-aspect-ratio: 970 / 618) {
            font-size: .8rem;
        }
        @media screen and (min-aspect-ratio: 970 / 530) {
            font-size: .7rem;
        }
        @media screen and (min-aspect-ratio: 970 / 468) {
            font-size: .6rem;
        }
        @media screen and (max-width: point(sm)) {
            font-size: .8rem;
            @media screen and (min-aspect-ratio: 375 / 800) {
                font-size: .7rem;
            }
            // @media screen and (min-aspect-ratio: 375 / 725) {
            //     font-size: .65rem;
            // }
            // @media screen and (min-aspect-ratio: 375 / 690) {
            //     font-size: .5rem;
            // }
            // @media screen and (min-aspect-ratio: 375 / 585) {
            //     font-size: .4rem;
            // }
            // @media screen and (min-aspect-ratio: 375 / 520) {
            //     font-size: .3rem;
            // }
        }
    }

    // animation styles before
    .tech-solution {
        &:before, &:after {
            opacity: 0;
            transition: calc(var(--content-appear-time) + .5s) opacity;
        }
        .tech-solution__canvas:after {
            opacity: 0;
            transition: calc(var(--content-appear-time) + .5s) opacity;
        }
    }
    // animation styles after
    .tech-solution.active {
        &:before, &:after {
            opacity: 1;
        }
        .tech-solution__canvas:after {
            opacity: 1;
        }
    }
</style>
